module.exports = __webpack_public_path__ + "img/home-3.5711652a.jpg";